module.exports = __webpack_public_path__ + "img/map-ch.b1b4cd69.png";